import { ROLE_NAMES } from "./role";

/*
  Users that can do top up
  PS: Can't use ROLE_NAMES const due to Circular Dependency
*/
export const CAN_TOPUP_ROLES = [
  ROLE_NAMES.ADMIN,
  ROLE_NAMES.EXECUTOR,
  ROLE_NAMES.APPROVER,
  ROLE_NAMES.REVIEWER,
  ROLE_NAMES.DEPOSIT_ADMIN,
  ROLE_NAMES.CHECKER
];

/*
  Status Codes for Top Up Deposit
*/
export const TOPUP_STATUS = {
  WAITING_CONFIRMATION: 0,
  CHECKING_TOP_UP: 10,
  WAITING_FOR_RECEIPT: 12,
  PROCESSED: 30,
  SUCCESS: 40,
  TRANSACTION_CANCELLED: 50,
  TRANSACTION_CANCELLED_SYSTEM: 51,
  TRANSACTION_CANCELLED_ADMIN: 52,
  TRANSACTION_FAILED: 60
};

/*
  Status Codes for User's Deposit Activation Status
*/
export const DEPOSIT_ACTIVATION_STATUS = {
  INACTIVE: 0,
  ACTIVE: 1,
  REJECTED: 2,
  BLOCKED: 3
};

/*
  Status Codes for Withdrawal
*/
export const WITHDRAWAL_STATUS = {
  NEW_TRANSACTION: 0,
  PENDING_GROUP: 1,
  READY_GROUP: 2,
  PROCESS_GROUP: 3,
  CANCEL_GROUP: 5,
  FAILED_GROUP: 6,
  HOLD_GROUP: 8,
  PENDING: 10,
  WAITING_RECEIPT: 12,
  READY: 20,
  WRONG_ACCOUNT: 22,
  IN_PROCESS: 30,
  SUCCESS: 40,
  SUCCESS_PARTIALLY: 41,
  CANCEL_USER: 50,
  CANCEL_SYSTEM: 51,
  CANCEL_ADMIN: 52,
  FAILED: 60,
  HOLD: 80
};
